var map = {
	"./avatar-placeholder.png": "194f",
	"./bg-alt.svg": "d590",
	"./bg-icon-white.png": "b67d",
	"./bg-icon.png": "7fab",
	"./bg-img.svg": "2295",
	"./flag-sprites.jpeg": "53ed",
	"./gradient-bg.svg": "29a0",
	"./logo-alt.svg": "417a",
	"./logo.svg": "e347",
	"./logos-appstore.png": "eed1",
	"./logos-playstore.png": "35ef",
	"./mobi-bg-img.svg": "7f10",
	"./payment-logos-absa.png": "2c6f",
	"./payment-logos-amex.png": "d6c7",
	"./payment-logos-clearbank.png": "0bd8",
	"./payment-logos-currencycloud.png": "834d",
	"./payment-logos-dinersclub.png": "1765",
	"./payment-logos-envisionit.png": "fe3f",
	"./payment-logos-fnb.png": "0d16",
	"./payment-logos-mastercard.png": "cfbd",
	"./payment-logos-masterpass.png": "637f",
	"./payment-logos-ozow.png": "e660",
	"./payment-logos-paypal.png": "8c18",
	"./payment-logos-snapscan.png": "3373",
	"./payment-logos-standard.png": "c38a",
	"./payment-logos-visa.png": "f469",
	"./payment-logos-zapper.png": "d31a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";